/*
 *
 * Package: `@dbh/switchable-view-hotel-list-map-theme`.
 *
 */const THEME_KEY_SWITCHABLE_VIEW_HOTEL_LIST_MAP="switchableViewHotelListMap";const list={xl:"788px",// The `XXL` value is manually calculated, we want to align the left edge
// of the map, to the right border of the search box category selector.
xxl:"860px"},modifySwitchableViewHotelListMapTheme=()=>({[THEME_KEY_SWITCHABLE_VIEW_HOTEL_LIST_MAP]:{list,map:{xl:"calc(100% - "+list.xl+")",xxl:"calc(100% - "+list.xxl+")"}}});

export { THEME_KEY_SWITCHABLE_VIEW_HOTEL_LIST_MAP, modifySwitchableViewHotelListMapTheme as default };
